<div class="create-property-category">
    <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()">
      <div class="form-group">
        <label for="name">Category Name</label>
        <input id="name" type="text" formControlName="name" pInputText />
        <div class="error" *ngIf="categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched">
          <small class="text-danger">Category name is required.</small>
        </div>
      </div>
  
      <div class="form-group">
        <label for="description">Description</label>
        <textarea class="w-100" id="description" formControlName="description" rows="3" pInputTextarea></textarea>
        <div class="error" *ngIf="categoryForm.get('description')?.invalid && categoryForm.get('description')?.touched">
         <small class="text-danger">Description is required.</small>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2 p-1">
        <p-button type="submit" class="secondary-btn" [disabled]="categoryForm.invalid">
          Save</p-button>
      </div>
    </form>
  </div>
  